import React from "react";
import Loading from "../components/shared/Loading";
import { useFetchMeQuery } from "../store";
import Person from "./person/Person";
import Manager from "./manager/Manager";
import { ADMIN, MANAGER } from "../roles";

const Content = () => {
  const { data: user, isLoading } = useFetchMeQuery();
  if (isLoading) return <Loading isLoading={isLoading} />;

  if (user.roleId === MANAGER || user.roleId === ADMIN) {
    return <Manager />;
  } else {
    return <Person />;
  }
};

export default Content;
